// extracted by mini-css-extract-plugin
export var banner = "_1i-0";
export var icon = "_1i-1";
export var message = "_1i-2";